<template>
  <div class="deck-box">
    <div class="header">
      <b>驾驶舱</b>
    </div>
    <div class="list">
      <div v-for="(item, i) in list" :key="'deck-'+i" class="item">
        <template v-if="item.permission">
          <div class="class">{{ item.label }}</div>
          <div class="deck-panel">
            <div v-for="(deck, j) in item.value" :key="j"  @click="toPath(i, deck)" class="deck">
              <span class="deck-label">{{ deck.label }}</span>
              <span class="deck-value">{{ deck.value }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { statistics, todoWork } from '@/api/workbench';
import { inquirePriceCount } from '@/api/inquiryForm';
import { sendRepairStatusStatistics } from '@/api/logistics';
export default {
  data () {
    return {
      disabled: false,
      list: [
        {
          label: '销售',
          title: 'xiaoshou',
          permission: this.$withPermission('workBench:cockpit:sale'),
          value: [
            { label: '待接单', value: 0, path: 'inquiryForm/customerInquiryForm/list?status=WAIT_TASK_ORDER' },
            { label: '待报价', value: 0, path: 'inquiryForm/customerInquiryForm/list?status=WAIT_QUOTE_PRICE' },
            { label: '待确认报价', value: 0, path: 'inquiryForm/customerInquiryForm/list?status=NEGOTIATING&negotiatingType=UPDATE' },
            { label: '合同待审核', value: 0, path: 'salesManagement/saleContract?status=6' },
            { label: '订单待发货', value: 0, path: 'salesManagement/pickUpOrders?status=waitDeliveryCount' },
            { label: '售后待审核', value: 0, path: 'afterSaleManagement/service?status=2' },
            { label: '售后待签收', value: 0, path: 'afterSaleManagement/service/return?status=1' },
          ],
        },
        {
          label: '履约',
          title: 'lvyue',
          permission: this.$withPermission('workBench:cockpit:lvyue'),
          value: [
            { label: '待签收寄修单', value: 0, path: 'logistics/sendForRepair/list?status=2' },
            { label: '待寄回寄修单', value: 0, path: 'logistics/sendForRepair/list?status=3' },
            { label: '待签收备用机', value: 0, path: 'logistics/backupEquipment/list?status=4' },
            { label: '待指派',
              value: 0,
              name: 'ORDER_INDEX',
              params: {
                independentStatusMsg: [{
                  value: 'TO_BE_ASSIGNED',
                  label: '待指派',
                }],
              },
            },
            { label: '待接单',
              value: 0,
              name: 'ORDER_INDEX',
              params: {
                independentStatusMsg: [{
                  value: 'PENDING_ORDERS',
                  label: '待接单',
                }],
              },
            },
            { label: '待完工',
              value: 0,
              name: 'ORDER_INDEX',
              params: {
                independentStatusMsg: [{
                  value: 'TO_BE_COMPLETED',
                  label: '待完工',
                }],
              },
            },
          ],
        },
        {
          label: '结算',
          title: 'jiesuan',
          permission: this.$withPermission('workBench:cockpit:jiesuan'),
          value: [
            { label: '对账单待确认', value: 0, path: 'reconciliation/accountStatement/list?status=wait' },
          ],
        },
      ],
    };
  },
  deactivated () {
    setTimeout(() => {
      this.disabled = false;
    }, 3000);
  },
  mounted () {
    this.init();
  },
  methods: {
    toPath (i, item) {
      if (this.disabled) return;
      if (
        (i === 0 && ['待接单', '待报价', '待确认报价'].includes(item.label) && this.$withPermission('gongxutong:inquire_price:customer_inquire'))
        || (i === 0 && ['合同待审核'].includes(item.label) && this.$withPermission('gongxutong:sale:contract'))
        || (i === 0 && ['订单待发货'].includes(item.label) && this.$withPermission('gongxutong:sale:order'))
        || (i === 0 && ['售后待审核'].includes(item.label) && this.$withPermission('gongxutong:sale_after:order'))
        || (i === 0 && ['售后待签收'].includes(item.label) && this.$withPermission('gongxutong:sale_after:return'))
        || (i === 1 && ['待签收寄修单', '待寄回寄修单'].includes(item.label) && this.$withPermission('gongxutong:customer_inquire:sendRepairList'))
        || (i === 1 && ['待签收备用机'].includes(item.label) && this.$withPermission('gongxutong:customer_inquire:sendRepairSpareList'))
        || (i === 1 && ['待指派', '待接单', '待完工'].includes(item.label) && this.$withPermission('workOrder:list'))
        || (i === 2 && ['对账单待确认'].includes(item.label) && this.$withPermission('gongxutong:reconciliation_settlement:statement'))
      ) {
        this.disabled = true;
        if (item.path) {
          this.$router.push({
            path: `${item.path}&timeStamp=${new Date().getTime()}`,
          });
        } else if (item.name) {
          this.$router.push({
            name: item.name,
            params: item.params || {},
          });
        }
      } else {
        this.$message.warning('暂无权限');
      }
    },
    async queryStatistics () {
      const data = await statistics({});
      if (data.body) {
        this.list[0].value[3].value = data.body.contractQuantity || 0;
        this.list[0].value[4].value = data.body.orderQuantity || 0;
        this.list[0].value[5].value = data.body.afterTBCQuantity || 0;
        this.list[0].value[6].value = data.body.afterTBRQuantity || 0;

        this.list[2].value[0].value = data.body.reconciliationQuantity || 0;
      }
    },
    async queryInquirePriceCount () {
      const data = await inquirePriceCount({});
      if (data.body) {
        this.list[0].value[0].value = data.body.waitTaskOrderCount || 0;
        this.list[0].value[1].value = data.body.waitQuotePriceCount || 0;
        this.list[0].value[2].value = data.body.negotiatingUpdateCount || 0;
      }
    },
    querySendRepairStatusStatistics () {
      sendRepairStatusStatistics({ type: 1 }).then(data => {
        if (data.body) {
          this.list[1].value[0].value = data.body.waitSendOutSignCount || 0;
          this.list[1].value[1].value = data.body.waitSendBackCount || 0;
        }
        sendRepairStatusStatistics({ type: 2 }).then(data2 => {
          if (data2.body) {
            this.list[1].value[2].value = data2.body.waitSendBackSignCount || 0;
          }
        });
      });
    },
    async queryTodoWork () {
      const data = await todoWork();
      if (data.body) {
        this.list[1].value[3].value = data.body.toBeAssignedNum || 0;
        this.list[1].value[4].value = data.body.pendingOrdersNum || 0;
        this.list[1].value[5].value = data.body.toBeCompletedNum || 0;
      }
    },
    init () {
      if (this.$withPermission('workBench:cockpit:sale') || this.$withPermission('workBench:cockpit:jiesuan')) {
        this.queryStatistics();
      }
      if (this.$withPermission('workBench:cockpit:sale')) {
        this.queryInquirePriceCount();
      }
      if (this.$withPermission('workBench:cockpit:lvyue')) {
        this.querySendRepairStatusStatistics();
        this.queryTodoWork();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.deck-box {
  font-size: 14px;
  color: #1F2733;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 15px 20px;
  margin-bottom: 8px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
  }
  .list {
    min-height: 250px;
    padding-top: 15px;
    .item {
      padding-bottom: 10px;
      .class {
        padding-top: 10px;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        &::before {
          content: ' ';
          display: inline-block;
          width: 2px;
          height: 12px;
          background: #237FFA;
          margin-right: 6px;
        }
      }
      .deck-panel {
        margin-top: 10px;
        .deck {
          min-width: 160px;
          cursor: default;
          display: inline-flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 6px;
          border: 1px solid #EBEDF0;
          padding: 12px 10px;
          margin-right: 10px;
          margin-bottom: 10px;
          .deck-label {
            font-weight: 400;
            font-size: 14px;
            color: #1F2733;
            padding-right: 20px;
          }
          .deck-value {
            font-size: 20px;
            color: #1F2733;
          }
        }
        .deck:hover {
          background: #F5F7FA;
          border: 1px solid #F5F7FA;
        }
      }
    }
  }
}
</style>
